<mat-toolbar class="d-flex flex-row flex-shrink-0 align-items-center justify-content-center top-bar"
[ngClass]="{'expanded': (layoutService.$sideNavExpanded | async) && (isHandset$ | async) === false}">
  <ng-template [ngIf]="layoutService.showDefaultToolbar | async" [ngIfElse]="customToolbarView">
    <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="toggleSidebarView()"
      *ngIf="(isHandset$ | async) && (layoutService.$showSideNavBar | async)">
      <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
    </button>
    <a class="d-flex align-items-center text-decoration-none" [routerLink]="['/home']" aria-label="Go to home">
      <div class="logo-large expanded-content clickable-logo">
        <img class="w-100" [src]="logoFile" alt="Drawout" loading="lazy" />
      </div>
      <div class="logo-small collapsed-content clickable-logo">
        <img class="w-100" src="assets/images/logo-3.ico" alt="Drawout" />
      </div>
    </a>
    <div class="d-flex flex-row flex-grow-1 align-items-center">
      <div class="w-100">
        <app-bread-crumb-view></app-bread-crumb-view>
      </div>

      <app-go-to-admin-button></app-go-to-admin-button>
      <!-- <app-organisation-settings-button></app-organisation-settings-button> -->

      <app-notification-opener-icon [userProfile]="userProfile" [notificationData]="notificationRealtimeService.data"
      (closeAvatar)="closeAvatar()" (openNotificationEmit)="openNotification()"
      (closeNotificationEmit)="closeNotification()"></app-notification-opener-icon>

      <app-profile-details-menu-view [userProfile]="userProfile"
      (closeNotification)="closeNotification()"></app-profile-details-menu-view>

    </div>
  </ng-template>
  <ng-template #customToolbarView>
    <ng-template [cdkPortalOutlet]="layoutService.$customToolbarComponent | async"></ng-template>
  </ng-template>
</mat-toolbar>
<mat-sidenav-container class="sidenav-container" (click)="closeAllPanel()" autosize>
  <mat-sidenav *ngIf="layoutService.$showSideNavBar | async" #drawer class="sidenav" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [fixedInViewport]="true" [fixedTopGap]="54"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
    <div class="do-sidenav d-flex flex-column h-100" [ngClass]="{'expanded': (layoutService.$sideNavExpanded | async) || (isHandset$ | async)}">

      <ng-template [cdkPortalOutlet]="layoutService.$sideNavComponent | async"></ng-template>

      <div class="flex-grow-1"></div>

      <!-- <app-support-user-details [sidenavExpanded]="(layoutService.$sideNavExpanded | async) || (isHandset$ | async)"></app-support-user-details> -->
      <!-- <app-subscription-details [sidenavExpanded]="(layoutService.$sideNavExpanded | async) || (isHandset$ | async)"></app-subscription-details> -->
      <div class="separator"></div>

      <div *ngIf="layoutService.$showNavbarExpandButton | async" class="nav-toggle flex-shrink-0 p-2 overflow-hidden d-flex" style="height: 40px;">
        <span class="ps-2 version expanded-content">
          {{version}}
        </span>
        <mat-slide-toggle mat-list-item
            [checked]="layoutService.$sideNavExpanded | async" (change)="toggleSideNavExpandedView()">
        </mat-slide-toggle>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="d-flex flex-column">
    <div class="flex-grow-1 overflow-y-auto overflow-x-hidden custom-scrollbar position-relative">
      <router-outlet></router-outlet>
      <app-notification #notificationContainer
      [notifications]="notificationRealtimeService.data ? notificationRealtimeService.data.notifications : null"
      (closeNotification)="closeNotification()" (click)="$event.stopPropagation()">
      </app-notification>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
